export enum EventState {
  CANCELLED = 'CANCELLED',
  POSTPONED = 'POSTPONED',
  RESCHEDULED = 'RESCHEDULED',
  UPCOMING = 'UPCOMING',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/event-state.ts